var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.onScroll),expression:"onScroll"},{name:"show",rawName:"v-show",value:(_vm.fab),expression:"fab"}],attrs:{"fab":"","dark":"","color":"primary","fixed":"","bottom":"","right":""},on:{"click":_vm.goToTop}},[_c('v-icon',[_vm._v("mdi-chevron-up")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }